import { render, staticRenderFns } from "./bottomRight.vue?vue&type=template&id=4b8eceea&"
import script from "./bottomRight.vue?vue&type=script&lang=js&"
export * from "./bottomRight.vue?vue&type=script&lang=js&"
import style0 from "./bottomRight.vue?vue&type=style&index=0&id=4b8eceea&prod&lang=scss&class=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports